import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { PartialityArea } from "./Styles";

export default function Partiality({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="Parcialidad"
            value={!value ? document.partialities.currentPartiality : value}
          />
        </div>
      ) : (
        <PartialityArea>
          <Informative
            readonly={true}
            label="Parcialidad"
            value={!value ? document.partialities.currentPartiality : value}
          />
        </PartialityArea>
      )}
    </>
  );
}
